
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { CarrierDialog } from "./CarrierDialog";
import { CarriersTable } from "./CarriersTable";
import { Building } from "lucide-react";

export const CarriersContainer = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedCarrier, setSelectedCarrier] = useState<any>(null);

  const { data: carriers, refetch } = useQuery({
    queryKey: ["carriers"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("carriers")
        .select("*")
        .order("name");

      if (error) throw error;
      return data;
    },
  });

  const handleEdit = (carrier: any) => {
    setSelectedCarrier(carrier);
    setIsDialogOpen(true);
  };

  const handleAdd = () => {
    setSelectedCarrier(null);
    setIsDialogOpen(true);
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-semibold">Manage Insurance Carriers</h2>
        <Button onClick={handleAdd} className="bg-primary hover:bg-primary/90 text-white">
          <Building className="h-4 w-4 mr-2" />
          Add Insurance Carrier
        </Button>
      </div>

      <CarriersTable
        carriers={carriers || []}
        onEdit={handleEdit}
      />

      <CarrierDialog
        carrier={selectedCarrier}
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        onSuccess={() => {
          refetch();
          setIsDialogOpen(false);
        }}
      />
    </div>
  );
};
